import { render, staticRenderFns } from "./ModalNewPrescription.vue?vue&type=template&id=61a4099c"
import script from "./ModalNewPrescription.vue?vue&type=script&lang=js"
export * from "./ModalNewPrescription.vue?vue&type=script&lang=js"
import style0 from "./ModalNewPrescription.vue?vue&type=style&index=0&id=61a4099c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a4099c')) {
      api.createRecord('61a4099c', component.options)
    } else {
      api.reload('61a4099c', component.options)
    }
    module.hot.accept("./ModalNewPrescription.vue?vue&type=template&id=61a4099c", function () {
      api.rerender('61a4099c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/applications/components/ModalNewPrescription.vue"
export default component.exports